import { executeLinksAPI } from "./LinksAPI";

class RemoteDate extends Date {
	static _lag = 0;
	constructor(...args) {
		if(args.length === 0) {
			super(RemoteDate.now());
		} else {
			super(...args);
		}
	}
	static now () {
		return super.now() + this._lag;
	}
	static getLag() {
		return this._lag;
	}
}

const beforeTime = Date.now();
const lt = beforeTime;
const remoteDatePromise = new Promise((resolve, reject) => {
	const config = {
		method: 'get',
		params: {
			lt
		},
	};
	executeLinksAPI('fosterlinks/server_time', config)
	.then(data => {
		const afterTime = Date.now();
		RemoteDate._lag = data.st - Math.round((afterTime + beforeTime) / 2);
		resolve(RemoteDate);
	})
	.catch(e => {
		reject("Date sync error.");
	});
});

export { remoteDatePromise };
